export const TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet';

export const AUTH_METHODS = {
  EMAIL: 'email',
  FACEBOOK: 'fb'
};
export const WHEEL_SPINNER = {
  SPINNER_BUTTON:'SPIN THE WHEEL',
};

export const TRACKING_ROUTES = {
  GEO: 'Unavailable Page',
  WINDOW: 'Closed Page',
  LOGIN: 'Login Page'
};

export const ROUTES = {
  HOME: '/',
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  ERROR: '/errors'
};

// API
export const ACTION_TYPES = {
  GET: 'get',
  VOTE: 'vote',
  LOGIN: 'login',
  REGISTER: 'register',
  SWEEPS: 'sweeps',
  CHECK_PRIZES: 'check_prizes'
};

// FB
export const FB_ERROR_TYPES = {
  GENERIC: 'fbGeneric',
  PERMISSIONS: 'fbPermissions'
};

// Auth Facebook
export const FACEBOOK_AUTH_TYPES = {
  REAUTHENTICATE: 'reauthenticate',
  REAUTHORIZE: 'reauthorize',
  REREQUEST: 'rerequest'
}

// Auth
export const LOCALSTORAGE = {
  AUTH: '_Auth'
}